import { MoreButton } from '@/components';
import { ProjectResourceGuard } from '@/features/authentication/_components/ProjectResourceGuard';
import { useProject } from '@/features/project/_hooks/project';
import { useId } from '@/hooks';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useProjectDetailDrawerState } from '../../_components/ProjectDrawerStateProvider';
import { UpdateExecutionProgressIncomeAndExpenditureSummaryFormDrawer } from './UpdateExecutionProgressIncomeAndExpenditureSummaryFormDrawer';

export const ExecutionProgressSummaryTableActions: FC = () => {
  const { t } = useTranslation();
  const { id: projectId } = useId();
  const project = useProject(projectId);
  const { setDrawerState } = useProjectDetailDrawerState();

  return (
    <ProjectResourceGuard onlyEdit>
      {project.data && !project.data.isLocked && (
        <>
          <MoreButton
            items={[
              {
                key: 'edit-income-and-expenditure',
                label: t('edit'),
              },
            ]}
            onClick={({ key }) => {
              if (key === 'edit-income-and-expenditure') {
                setDrawerState({
                  open: true,
                  type: 'execution-progress-income-and-expenditure-summary',
                });
              }
            }}
          />
          <UpdateExecutionProgressIncomeAndExpenditureSummaryFormDrawer />
        </>
      )}
    </ProjectResourceGuard>
  );
};
